import appConstants from "@appConstants";
 
// Wait this long after load before calling print
const PDF_PRINT_DEFER_MS = appConstants.SEARCH_DEBOUNCE_DELAY;

// If the browser never tells us printing finished, run cleanup after this long 1 min
const PRINT_CLEANUP_FALLBACK_MS = appConstants.ONE_MINUTE_TIME_OUT;

//Create an invisible mini-browser, load the PDF into it, wait a bit so it renders properly, open the print dialog, and then clean everything up after the user finishes (or after a timeout just in case).
export function printPdfBlobUrl(blobUrl: string, onDone?: () => void): void {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("title", "Physical DR print");
  Object.assign(iframe.style, {
    position: "fixed",
    right: "0",
    bottom: "0",
    width: "0",
    height: "0",
    border: "0",
    visibility: "hidden",
  });
  document.body.appendChild(iframe);

  const cleanup = () => {
    try {
      iframe.remove();
    } catch (_e) {
      /* ignore */
    }
    onDone?.();
  };

  iframe.onload = () => {
    const win = iframe.contentWindow;
    if (!win) {
      cleanup();
      return;
    }
    // Short wait so the PDF is usually on screen before we open print (see file comment).
    const runPrint = () => {
      try {
        win.focus();
        win.print();
      } catch (_e) {
        cleanup();
        return;
      }
      win.addEventListener("afterprint", cleanup, { once: true });
      window.setTimeout(cleanup, PRINT_CLEANUP_FALLBACK_MS);
    };
    window.setTimeout(runPrint, PDF_PRINT_DEFER_MS);
  };

  iframe.onerror = () => cleanup();
  iframe.src = blobUrl;
}
